import { isStatsigInitialized } from '@eventbrite/statsig';
import React from 'react';
import { useIsServerSideRendered } from '../hooks/useIsServerSideRendered';
import './OrganizerPanel.scss';

export type OrganizerPanelLayoutProps = {
    shouldShowMoreEventsFromThisOrganizer?: boolean;
};

export const OrganizerPanelLayout = ({
    shouldShowMoreEventsFromThisOrganizer,
}: OrganizerPanelLayoutProps) => {
    const isServerSideRendered = useIsServerSideRendered();

    const hideUntilStatsigIsInitializedClass =
        isServerSideRendered ||
        (!isServerSideRendered && !isStatsigInitialized())
            ? 'eds-is-hidden-accessible'
            : '';

    return (
        <section
            className={`listing-organizer l-section eds-l-pad-bot-5 ${hideUntilStatsigIsInitializedClass}`}
        >
            <div
                id="listings-root__organizer-panel"
                className="organizer-panel"
            ></div>
            {shouldShowMoreEventsFromThisOrganizer && (
                <div id="listings-root__more-events-from-this-organizer"></div>
            )}
            <div id="listings-root__collections-related-to-this-event"></div>
        </section>
    );
};
